import {
  Image,
  ScrollView,
  Text,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
} from "react-native";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { getLoginData } from "../../../utility/AppStoreData";
import { AppImages } from "../../../utility/AppImages";
import DateTimePickerModal from "../WebScreens/Common/DateTimePickerModal";
import dayjs from "dayjs";
import { StackActions } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppScreens } from "../../Utility/AppScreens";
import { toast } from "react-toastify";
import CompetitorsModal from "../WebScreens/CreateEvents/CompetitorsModal";
import {
  fetchPaymentBeltExchange,
  fetchUserBalance,
} from "../../../services/profileAPI";
import { handleApiError } from "../../../services/errorHandler";
import { fetchGenreGames } from "../../../services/authAPI";
import CornfirmPurchaseBeltModal from "../WebScreens/BeltScreens/CornfirmPurchaseBeltModal";
import StreamingAccountModal from "../WebScreens/CreateEvents/StreamingAccountModal";
import ConnetedPopup from "../WebScreens/CreateEvents/ConnetedPopup";
import NoBalancePopup from "../WebScreens/CreateEvents/NoBalancePopup";
import Header from "../WebScreens/Common/Header";
import ChallengeModeComponent from "../../../Components/create-event-components/ChallengeModeComponent";
import EventNameAndGameComponent from "../../../Components/create-event-components/EventNameAndGameComponent";
import Separator from "../../../Components/Separator";
import DeviceAndGameIdComponent from "../../../Components/create-event-components/DeviceAndGameIdComponent";
import DescriptionAndImageComponent from "../../../Components/create-event-components/DescriptionAndImageComponent";
import SelectBeltsComponent from "../../../Components/create-event-components/SelectBeltsComponent";
import SchedulingEventComponent from "../../../Components/create-event-components/SchedulingEventComponent";
import InefficientBeltsPopup from "../WebScreens/CreateEvents/InefficientBeltsPopup";
import BeltPurchaseSuccessModal from "../WebScreens/BeltScreens/BeltPurchaseSuccessModal";
import DurationAndQualityComponent from "../../../Components/create-event-components/DurationAndQualityComponent";
import TicketPriceAndQuantityComponent from "../../../Components/create-event-components/TicketPriceAndQuantityComponent";
import { SwitchCommon } from "../../../common/SwitchCommon";
import RevenueSplitComponent from "../../../Components/create-event-components/RevenueSplitComponent";
import { ScreenBGGradientView } from "../../../common/CommonView";
export enum enumAddEditPublicPrivateScreen {
  Add = "Add",
  Edit = "Edit",
}

const exchangeRates = {
  bronze: 550,
  silver: 5500,
  gold: 55000,
  platinum: 550000,
};

const sellRates = {
  bronze: 5,
  silver: 50,
  gold: 500,
  platinum: 5000,
};
export default function CreatePrivateEventScreen({ navigation, route }) {
  // this is for private event
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [commonSwitch, setCommonSwitch] = useState(false);
  const [organiserId, setOrganiserId] = useState("");
  const [eventType, setEventType] = useState(route.params.eventType);
  const [dateTimeInput, setDateTimeInput] = useState("");
  const [eventName, setEventName] = useState("");
  const [minAttendees, setMinAttendees] = useState("100");
  const [maxAttendees, setMaxAttendees] = useState("300");
  const [selectStake, setSelectStake] = useState([""]);
  // const [amount, setAmount] = useState([]);
  // const [minAttendees, setMinAttendees] = useState("");
  const [description, setDescription] = useState("");
  const [userData, setUserData] = useState(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectDate, setSelectDate] = useState("");
  const [selectTime, setSelectTime] = useState("");
  const [duration, setDuration] = useState("1 hour");
  const [timeLimit, setTimeLimit] = useState("2 day");

  const [organizerSplit, setOrganizerSplit] = useState(50);
  const [challengerSplit, setChallengerSplit] = useState(50);
  const [quality, setQuality] = useState("Standard (720p, 30fps)");
  const [challengeMode, setChallengeMode] = useState("1 VS 1");
  const [playType, setPlayType] = useState("Competitive");
  const [selectGame, setSelectGame] = useState("");
  // const [ticketPrice, setTicketPrice] = useState("");
  const [gamerID, setGamerID] = useState("");
  const [device, setDevice] = useState("");
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [
    tooltipForCompeteWithoutStreamingVisible,
    setTooltipForCompeteWithoutStreamingVisible,
  ] = useState(false);
  const [tooltipForGift, setTooltipForGift] = useState(false);
  const [refreshAPICall, setRefreshAPICall] = useState(false);
  const [beltsTooltip, setBeltsTooltip] = useState(false);
  const [durationAndQualityTooltip, setDurationAndQualityTooltip] =
    useState(false);
  const [splitTooltip, setSplitTooltip] = useState(false);
  const [ticketRefundTooltip, setTicketRefundTooltip] = useState(false);
  const [ticketPriceTooltip, setTicketPriceTooltip] = useState(false);
  const [ticketQuantityTooltip, setTicketQuantityTooltip] = useState(false);
  const [competitorModel, setCompetitorModel] = useState(false);
  const [accessToken, setAccessToken] = useState("");
  const [apiData, setApiData] = useState({});
  const [cornfirmPurchaseBeltModal, setCornfirmPurchaseBeltModal] =
    useState(false);
  const [beltPurchaseSuccessModal, setBeltPurchaseSuccessModal] =
    useState(false);
  // Switchies

  const [youTubeSwitch, setYouTubeSwitch] = useState(false);
  const [streamingSwitch, setStreamingSwitch] = useState(false);
  const [twitchSwitch, setTwitchSwitch] = useState(true);

  const [chatSwitch, setChatSwitch] = useState(false);
  const [competitorSwitch, setCompetitorSwitch] = useState(false);
  const [allOrNothingSwitch, setAllOrNothingSwitch] = useState(false);
  const [publicVotingEnabled, setPublicVotingEnabled] = useState(false);

  const [showLoader, setShowLoader] = useState(false);
  const [userBalanceData, setUserBalanceData] = useState(null);
  // const [ticketSystem, setTicketSystem] = useState("Token");
  const [balancePopup, setBalancePopup] = useState(false);
  const [inefficientBeltsPopup, setInefficientBeltsPopup] = useState(false);
  const [beltDetailTooltip, setBeltDetailTooltip] = useState(false);
  const [fileContent, setFileContent] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [stakeCurrentPrize, setStakeCurrentPrize] = useState([]);
  const [stakeTokenAmount, setStakeTokenAmount] = useState(0);
  const [stakeCurrencyAmount, setStakeCurrencyAmount] = useState(0);
  const [totalUserAvaialableBelts, setTotalUserAvaialableBelts] = useState(0);
  const [arrDetermineStakes, setArrDetermineStakes] = useState([
    {
      id: 0,
      value: 0,
      image: AppImages.icCoinBelt,
      isAvailableAmountSelected: 1,
      title: "Coin",
      isSelected: false,
      currentPrize: 0,
      sellPrice: 0,
      locked: true,
      purchaseLock: true,
      stakeTokenAmount: 0,
      stakeBeltAmount: 0,
      stakeCurrencyAmount: 0,
      purchasedBeltAmount: 0,
      width:
        deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
          ? 69
          : 77,
      height: 69,
      popupIconWidth: 58,
    },
    {
      id: 1,
      value: 0,
      image: AppImages.icBronzeBelt,
      isAvailableAmountSelected: 1,
      title: "Bronze",
      isSelected: true,
      currentPrize: 0,
      sellPrice: 0,
      locked: true,
      purchaseLock: true,
      stakeTokenAmount: 0,
      stakeBeltAmount: 0,
      stakeCurrencyAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 2,
      value: 0,
      image: AppImages.icSilverBelt,
      isAvailableAmountSelected: 0,
      title: "Silver",
      isSelected: true,
      currentPrize: 0,
      sellPrice: 0,
      locked: true,
      purchaseLock: true,
      stakeTokenAmount: 0,
      stakeBeltAmount: 0,
      stakeCurrencyAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 3,
      value: 0,
      image: AppImages.icGoldBelt,
      isAvailableAmountSelected: 0,
      title: "Gold",
      isSelected: false,
      currentPrize: 0,
      sellPrice: 0,
      locked: true,
      purchaseLock: true,
      stakeTokenAmount: 0,
      stakeBeltAmount: 0,
      stakeCurrencyAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 4,
      value: 0,
      name: "Platinum",
      image: AppImages.icPlatinumBelt,
      isAvailableAmountSelected: 0,
      title: "Platinum",
      isSelected: false,
      currentPrize: 0,
      sellPrice: 0,
      locked: true,
      purchaseLock: true,
      stakeTokenAmount: 0,
      stakeBeltAmount: 0,
      stakeCurrencyAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
  ]);

  useEffect(() => {
    const savedEventData = localStorage.getItem("createEventData");

    if (savedEventData) {
      const parsedEventData = JSON.parse(savedEventData);

      // Set state with the parsed data from localStorage
      setEventType(parsedEventData.eventType || route.params.eventType);
      setEventName(parsedEventData.title || "");
      setSelectGame(parsedEventData.gameTitle || "");
      setDevice(parsedEventData.device || "");
      setGamerID(parsedEventData.gamerId || "");
      setDescription(parsedEventData.description || "");
      setFileContent(parsedEventData.eventImageUrl.fileContent || null);
      setFileName(parsedEventData.eventImageUrl.fileName || null);
      setSelectDate(parsedEventData.selectedDate || "");
      setSelectTime(parsedEventData.selectedTime || "");
      setDateTimeInput(parsedEventData.startDateTime || "");
      setSelectStake(parsedEventData.stakeType || "");
      setAllOrNothingSwitch(parsedEventData.allOrNothingSwitch || false);
      setPublicVotingEnabled(parsedEventData.publicVotingEnabled || false);
      setArrDetermineStakes((cur) =>
        cur.map((item, index) => ({
          ...item,
          stakeBeltAmount: parsedEventData.stakeAmount[index] || 0,
        }))
      );
      updateSelectStakeAndAmount();
      setChallengeMode(parsedEventData.challengeMode || "1 VS 1");
      setPlayType(parsedEventData.playType || "Competitive");
      setYouTubeSwitch(parsedEventData.youTubeSwitch || false);
      setTwitchSwitch(parsedEventData.twitchSwitch || true);
      setStreamingSwitch(parsedEventData.streamingSwitch || false);
      setChatSwitch(parsedEventData.chatSwitch || false);
      setCompetitorSwitch(parsedEventData.competitorSwitch || false);
      setOrganiserId(parsedEventData.organiserId || organiserId);
      setStakeCurrentPrize(
        stakeCurrentPrize.length > 0
          ? stakeCurrentPrize
          : [65, 650, 6500, 65000]
      );
    }
  }, []);

  useEffect(() => {
    const createEventData = {
      organiserId: organiserId,
      eventType: eventType,
      title: eventName,
      gameTitle: selectGame,
      device: device,
      gamerId: gamerID,
      description: description,
      eventImageUrl: {
        fileName,
        fileContent,
      },
      selectedDate: selectDate,
      selectedTime: selectTime,
      startDateTime: dateTimeInput,
      stakeType: selectStake,
      stakeAmount: arrDetermineStakes.map((item) => item.stakeBeltAmount),
      challengeMode: challengeMode,
      playType: playType,
      youTubeSwitch: youTubeSwitch,
      twitchSwitch: twitchSwitch,
      streamingSwitch: streamingSwitch,
      chatSwitch: chatSwitch,
      competitorSwitch: competitorSwitch,
      allOrNothingSwitch: allOrNothingSwitch,
      publicVotingEnabled: publicVotingEnabled,
      stakeCurrentPrize: stakeCurrentPrize,
    };

    localStorage.setItem("createEventData", JSON.stringify(createEventData));
  }, [
    organiserId,
    eventType,
    eventName,
    selectStake,
    arrDetermineStakes,
    description,
    selectDate,
    selectTime,
    dateTimeInput,
    duration,
    challengeMode,
    playType,
    selectGame,
    gamerID,
    device,
    youTubeSwitch,
    twitchSwitch,
    streamingSwitch,
    chatSwitch,
    competitorSwitch,
    allOrNothingSwitch,
    publicVotingEnabled,
    fileName,
    fileContent,
    stakeCurrentPrize,
  ]);

  const checkUserBalanceAPI = async (accessTokenValue) => {
    setShowLoader(true);

    try {
      const data = await fetchUserBalance(accessTokenValue);
      setShowLoader(false);

      if (data) {
        setUserBalanceData(data.body);

        const belts = data.body?.belts;
        const coins = data.body?.coins || 0;
        let totalAvailableBelts = 0;

        const arr = [...arrDetermineStakes];

        // Only process belts if they exist
        if (belts) {
          arr.map((item) => {
            if (item.title === "Bronze") {
              item.value = Number(belts.bronze || 0);
              totalAvailableBelts += Number(belts.bronze || 0);
              if (belts.bronze > 0) item.locked = false;
              item.purchaseLock = false;
            } else if (item.title === "Silver") {
              item.value = Number(belts.silver || 0);
              totalAvailableBelts += Number(belts.silver || 0);
              if (belts.silver > 0) item.locked = false;
            } else if (item.title === "Gold") {
              item.value = Number(belts.gold || 0);
              totalAvailableBelts += Number(belts.gold || 0);
              if (belts.gold > 0) item.locked = false;
            } else if (item.title === "Platinum") {
              item.value = Number(belts.platinum || 0);
              totalAvailableBelts += Number(belts.platinum || 0);
              if (belts.platinum > 0) item.locked = false;
            } else if (item.title === "Coin") {
              item.value = Number(coins);
              if (coins > 0) item.locked = false;
            }
          });
        }

        setTotalUserAvaialableBelts(totalAvailableBelts);
        showBalancePopups(data.body);
        setArrDetermineStakes((prev) =>
          prev.map((item, index) => ({
            ...arr[index],
            stakeBeltAmount: item.stakeBeltAmount,
          }))
        );
        updateSelectStakeAndAmount();

        setRefreshAPICall(false);
      } else {
        handleApiError(data.status, data.error);
        setRefreshAPICall(false);
      }
    } catch (error) {
      setShowLoader(false);
      setRefreshAPICall(false);
      toast.error(error.message);
    }
  };
  const showBalancePopups = (data: { balance: number; coins: number }) => {
    const { balance, coins } = data;
    const noBelts = totalUserAvaialableBelts === 0;

    // Show Balance Popup conditions
    if (
      (balance === 0 && coins < 20) ||
      (balance === 0 && coins === 0 && noBelts) ||
      (balance < 65 && coins < 20 && noBelts)
    ) {
      setBalancePopup(true);
      return;
    }

    // Show Inefficient Belts Popup conditions
    if (balance > 64 && (coins === 0 || coins < 20) && noBelts) {
      setInefficientBeltsPopup(true);
    }
  };

  window.addEventListener("popstate", () => showBalancePopups(userBalanceData));

  // Belt purchase cost in tokens (what you PAY to BUY a belt)
  const beltPurchaseRates = {
    Bronze: 550,
    Silver: 5500,
    Gold: 55000,
    Platinum: 550000,
  };

  const paymentBeltExchangeAPI = async (accessTokenValue) => {
    setShowLoader(true);

    try {
      const response = await fetchPaymentBeltExchange(accessTokenValue);
      setShowLoader(false);
      if (response.statusCode === 200) {
        const arr = [...arrDetermineStakes];
        const stakeCurrentPrize = [];
        arr.map((item) => {
          if (item.title === "Bronze") {
            item.currentPrize = beltPurchaseRates.Bronze;
            item.sellPrice = response.sellRates.bronze;
          } else if (item.title === "Silver") {
            item.currentPrize = beltPurchaseRates.Silver;
            item.sellPrice = response.sellRates.silver;
          } else if (item.title === "Gold") {
            item.currentPrize = beltPurchaseRates.Gold;
            item.sellPrice = response.sellRates.gold;
          } else if (item.title === "Platinum") {
            item.currentPrize = beltPurchaseRates.Platinum;
            item.sellPrice = response.sellRates.platinum;
          }
          stakeCurrentPrize.push(item.currentPrize);
        });
        setStakeCurrentPrize(stakeCurrentPrize);
        setArrDetermineStakes((prev) =>
          prev.map((item, index) => ({
            ...arr[index],
            stakeBeltAmount: item.stakeBeltAmount,
          }))
        );
        updateSelectStakeAndAmount();
      } else {
        handleApiError(response.statusCode, response.error);
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  };

  useEffect(() => {
    // editEvent();
    getLoginUserData((data) => {
      checkUserBalanceAPI(data.AccessToken);
      paymentBeltExchangeAPI(data.AccessToken);
    });
  }, [refreshAPICall]);

  useEffect(() => {
    if (route?.params?.token) {
      setCornfirmPurchaseBeltModal(true);
    }
  }, [route?.params]);

  async function getLoginUserData(success) {
    const data = await getLoginData();

    if (data != null) {
      setUserData(data);
      setAccessToken(data.AccessToken);
      success(data);
      setOrganiserId(data.username);
    }
  }

  const totalStakeBeltAmount = arrDetermineStakes
    .filter((item) => item.stakeBeltAmount > 0)
    .reduce((acc, item) => acc + item.stakeBeltAmount, 0);

  const updateSelectStakeAndAmount = () => {
    let selectedBelts = [];
    let totalAmount = [];

    arrDetermineStakes.forEach((belt) => {
      selectedBelts.push(belt.title);
      totalAmount.push(belt.stakeBeltAmount ? belt.stakeBeltAmount : 0);
    });
    setSelectStake(selectedBelts);
  };

  useEffect(() => {
    updateSelectStakeAndAmount();
  }, [arrDetermineStakes]);

  function checkValidation() {
    const coinsStakeBeltAmount = arrDetermineStakes
      .filter((item) => item.title === "Coin")
      .at(0).stakeBeltAmount;
    const isAnyOtherBeltSelected = arrDetermineStakes
      .filter((item) => item.title !== "Coin")
      .some((item) => item.stakeBeltAmount > 0);

    if (eventName === "") {
      toast.error("Please enter event name");
    } else if (!isAnyOtherBeltSelected && coinsStakeBeltAmount < 20) {
      toast.error("Select At least 20 coins");
    }
    // else if (minAttendees === "") {
    //     toast.error("Please enter min number attendees");
    // }
    else if (gamerID === "") {
      toast.error("Please enter Gamer ID");
    } else if (description === "") {
      toast.error("Please enter description");
    } else if (totalStakeBeltAmount === 0) {
      toast.error("You didn't have selected belts, Please first select belt");
    }
    // else if (selectStake === "") {
    //    toast.error("Please select stake");
    // }
    else if (dateTimeInput === "") {
      toast.error("Please enter Date and Time");
    } else if (selectDate === "") {
      toast.error("Please select date");
    } else if (selectTime === "") {
      toast.error("Please select time");
    } else if (selectGame === "") {
      toast.error("Please select game");
    }
    // else if (duration === "") {
    //     toast.error("Please enter duration");
    // }
    // else if (playType === "") {
    //     toast.error("Please select play type");
    // }
    // else if (gameType === "") {
    //    toast.error("Please select game type");
    // }
    else if (!youTubeSwitch && !twitchSwitch) {
      toast.error("You must enable either YouTube or Twitch streaming.");
    } else if (youTubeSwitch && twitchSwitch) {
      toast.error(
        "You cannot enable both YouTube and Twitch streaming at the same time."
      );
    } else {
      if (route.params.checkScreen === enumAddEditPublicPrivateScreen.Edit) {
        setCompetitorModel(true);
      } else {
        navigateToScreen(navigation, AppScreens.PrivateEventSummary, {
          eventType: route.params.eventType,
        });
      }
    }
  }

  const [games, setGames] = useState([]);
  const getGenreGames = async () => {
    try {
      const response = await fetchGenreGames();
      const responseBody =
        typeof response.body === "string"
          ? JSON.parse(response.body)
          : response.body;

      if (response.statusCode === 200) {
        const gamesList = responseBody.map((game) => game.title);

        setGames(gamesList);
        setShowLoader(false);
      } else {
        toast.error(responseBody.error);
      }
    } catch (error) {
      console.error("get games API Error:- ", error.message);
      toast.error(error.message);
    }
  };
  useEffect(() => {
    getGenreGames();
  }, []);

  const handleOutsideClick = () => {
    if (tooltipVisible) {
      setTooltipVisible(false);
    }
    if (tooltipForCompeteWithoutStreamingVisible) {
      setTooltipForCompeteWithoutStreamingVisible(false);
    }
    if (tooltipForGift) {
      setTooltipForGift(false);
    }
    if (showYoutubePopup) {
      setShowYoutubePopup(false);
    }
    if (showTwitchPopup) {
      setShowTwitchPopup(false);
    }
    if (connectedPopup) {
      setConnectedPopup(false);
    }
    if (beltsTooltip) {
      setBeltsTooltip(false);
    }
    if (durationAndQualityTooltip) {
      setDurationAndQualityTooltip(false);
    }
    if (splitTooltip) {
      setSplitTooltip(false);
    }
    if (ticketRefundTooltip) {
      setTicketRefundTooltip(false);
    }
    if (ticketPriceTooltip) {
      setTicketPriceTooltip(false);
    }
    if (ticketQuantityTooltip) {
      setTicketQuantityTooltip(false);
    }
    if (beltDetailTooltip) {
      setBeltDetailTooltip(false);
    }
    if (isOpen) {
      setIsOpen(false);
    }
    if (isOpenDuration) {
      setIsOpenDuration(false);
    }
    if (isOpenQuality) {
      setIsOpenQuality(false);
    }
    if (isOpenTimeLimit) {
      setIsOpenTimeLimit(false);
    }
  };
  const [showYoutubePopup, setShowYoutubePopup] = useState(false);
  const [showTwitchPopup, setShowTwitchPopup] = useState(false);
  const [connectedPopup, setConnectedPopup] = useState(false);

  const handleSwitchToggle = (value) => {
    setYouTubeSwitch(true);
    setTwitchSwitch(false);
    // if (value) {
    //   setShowYoutubePopup(true);
    // }
  };

  const handleTwitchSwitchToggle = (value) => {
    setTwitchSwitch(true);
    setYouTubeSwitch(false);
    // if (value) {
    //   setShowTwitchPopup(true);
    // }
  };
  const closePopup = () => {
    if (showYoutubePopup) {
      setShowYoutubePopup(false);
    }
    if (showTwitchPopup) {
      setShowTwitchPopup(false);
    }
  };

  useEffect(() => {
    if (connectedPopup) {
      closePopup();
    }
  }, [connectedPopup]);

  const scrollViewRef = useRef(null);

  const [normalizedSelectGame, setNormalizedSelectGame] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenDuration, setIsOpenDuration] = useState(false);
  const [isOpenQuality, setIsOpenQuality] = useState(false);
  const [isOpenTimeLimit, setIsOpenTimeLimit] = useState(false);

  useEffect(() => {
    const matchedGame = games.find(
      (game) => game.toLowerCase() === selectGame.toLowerCase()
    );

    if (matchedGame) {
      setNormalizedSelectGame(matchedGame);
    } else {
      setNormalizedSelectGame("");
    }
  }, [games, selectGame]);

  const formattedBeltString = useMemo(() => {
    const selectedBeltArray = arrDetermineStakes
      .filter((item) => item.stakeBeltAmount > 0)
      .map((item) => `${item.stakeBeltAmount} ${item.title}`);
    return selectedBeltArray.length > 0 ? selectedBeltArray.join(", ") : "0";
  }, [arrDetermineStakes]);

  const totalStakeTokenAmount = arrDetermineStakes.reduce((acc, item) => {
    const rate = exchangeRates[item.title.toLowerCase()] || 0;
    return acc + item.stakeBeltAmount * rate;
  }, 0);

  const totalStakeCurrencyAmount = arrDetermineStakes
    .reduce((acc, item) => {
      const sellRate = sellRates[item.title.toLowerCase()] || 0;
      return acc + item.stakeBeltAmount * sellRate;
    }, 0)
    .toFixed(2);

  const getFormattedBeltString = () => {
    const selectedBeltArray = arrDetermineStakes
      .filter((item) => item.stakeBeltAmount > 0)
      .map((item) => `${item.stakeBeltAmount} ${item.title}`);

    return selectedBeltArray.length > 0 ? selectedBeltArray.join(", ") : "0";
  };

  return (
    <TouchableWithoutFeedback onPress={handleOutsideClick}>
      <View style={[styles.container, {}]}>
        <ScreenBGGradientView />
        <Header
          btnSearchTapped={() => {
            navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
          }}
          btnWalletTapped={() => {}}
          btnStartTutorialTapped={() => {}}
          btnMessageTapped={() => {}}
          btnNotificationTapped={() => {}}
          btnProfileTapped={() => {}}
        />
        <View style={[styles.mainView]}>
          <View style={{ alignSelf: "flex-start" }}>
            <Text
              style={[
                deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                  ? AppFontStyle.BOLD_ANYBODY_32
                  : AppFontStyle.BOLD_ANYBODY_20,
                {
                  color: AppColors.white,
                  alignSelf: "center",
                },
              ]}
            >
              {(route.params.checkScreen || "Add") ===
              enumAddEditPublicPrivateScreen.Add
                ? "Create Event"
                : "Edit Event"}
            </Text>
          </View>

          <View
            style={[
              styles.divider,
              {
                width:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? "100%"
                    : "80%",
              },
            ]}
          />

          <ScrollView showsVerticalScrollIndicator={false} ref={scrollViewRef}>
            {/* Back & Next Buttons  */}
            <View
              style={{
                width:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.MD ||
                  deviceSize === DEVICE_SIZES.LG
                    ? "100%"
                    : "80%",
              }}
            >
              <View>
                <ChallengeModeComponent challengeMode={challengeMode} />
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    { marginBottom: 12, marginTop: 24 },
                  ]}
                >
                  Event Details
                </Text>

                <View style={{ gap: 17 }}>
                  <EventNameAndGameComponent
                    eventName={eventName}
                    setEventName={setEventName}
                    games={games}
                    setSelectGame={setSelectGame}
                    normalizedSelectGame={normalizedSelectGame}
                  />
                  <Separator
                    color={AppColors.appGrayColor_1C1C1C}
                    height={2}
                    marginTop={0}
                    marginBottom={0}
                    marginHorizontal={0}
                  />
                  <DeviceAndGameIdComponent
                    device={device}
                    setDevice={setDevice}
                    gamerID={gamerID}
                    setGamerID={setGamerID}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    setIsOpenDuration={setIsOpenDuration}
                    setIsOpenQuality={setIsOpenQuality}
                    scrollViewRef={scrollViewRef}
                  />
                  <DescriptionAndImageComponent
                    isOpen={isOpen}
                    description={description}
                    setDescription={setDescription}
                    setFileName={setFileName}
                    fileContent={fileContent}
                    setFileContent={setFileContent}
                    beltsTooltip={beltsTooltip}
                    type="create"
                    scrollViewRef={scrollViewRef}
                    durationAndQualityTooltip={durationAndQualityTooltip}
                  />
                  <Separator
                    color={AppColors.appGrayColor_1C1C1C}
                    height={2}
                    marginTop={0}
                    marginBottom={0}
                    marginHorizontal={0}
                  />
                  <SchedulingEventComponent
                    selectTime={selectTime}
                    setSelectTime={setSelectTime}
                    selectDate={selectDate}
                    setSelectDate={setSelectDate}
                    setShowDatePicker={setShowDatePicker}
                    scrollViewRef={scrollViewRef}
                  />
                  <Separator
                    color={AppColors.appGrayColor_1C1C1C}
                    height={2}
                    marginTop={0}
                    marginBottom={0}
                    marginHorizontal={0}
                  />
                  <DurationAndQualityComponent
                    setIsOpen={setIsOpen}
                    isOpenDuration={isOpenDuration}
                    setIsOpenDuration={setIsOpenDuration}
                    duration={duration}
                    setDuration={setDuration}
                    isOpenQuality={isOpenQuality}
                    setIsOpenQuality={setIsOpenQuality}
                    quality={quality}
                    setQuality={setQuality}
                    type="create"
                    durationAndQualityTooltip={durationAndQualityTooltip}
                    setDurationAndQualityTooltip={setDurationAndQualityTooltip}
                  />
                  <Separator
                    color={AppColors.appGrayColor_1C1C1C}
                    height={2}
                    marginTop={0}
                    marginBottom={0}
                    marginHorizontal={0}
                  />
                  <TicketPriceAndQuantityComponent
                    isOpenDuration={isOpenDuration}
                    isQualityOpen={isOpenQuality}
                    minAttendees={minAttendees}
                    setMinAttendees={setMinAttendees}
                    maxAttendees={maxAttendees}
                    setMaxAttendees={setMaxAttendees}
                    isOpenTimeLimit={isOpenTimeLimit}
                    setTimeLimit={setTimeLimit}
                    timeLimit={timeLimit}
                    setIsOpenTimeLimit={setIsOpenTimeLimit}
                    setIsOpen={setIsOpen}
                    setIsOpenQuality={setIsOpenQuality}
                    setIsOpenDuration={setIsOpenDuration}
                    ticketRefundTooltip={ticketRefundTooltip}
                    setTicketRefundTooltip={setTicketRefundTooltip}
                    ticketPriceTooltip={ticketPriceTooltip}
                    setTicketPriceTooltip={setTicketPriceTooltip}
                    ticketQuantityTooltip={ticketQuantityTooltip}
                    setTicketQuantityTooltip={setTicketQuantityTooltip}
                  />
                  <Separator
                    color={AppColors.appGrayColor_1C1C1C}
                    height={2}
                    marginTop={0}
                    marginBottom={0}
                    marginHorizontal={0}
                  />
                  <SelectBeltsComponent
                    isOpenDuration={isOpenDuration}
                    isQualityOpen={isOpenQuality}
                    setStakeTokenAmount={setStakeTokenAmount}
                    setStakeCurrencyAmount={setStakeCurrencyAmount}
                    stakeCurrentPrize={stakeCurrentPrize}
                    setCornfirmPurchaseBeltModal={setCornfirmPurchaseBeltModal}
                    arrBeltMedalType={arrDetermineStakes}
                    setArrBeltMedalType={setArrDetermineStakes}
                    beltsTooltip={beltsTooltip}
                    setBeltsTooltip={setBeltsTooltip}
                    isOpenTimeLimit={isOpenTimeLimit}
                    setBeltDetailTooltip={setBeltDetailTooltip}
                    scrollViewRef={scrollViewRef}
                    eventType={"Exclusive"}
                    splitTooltip={splitTooltip}
                  />
                  <Separator
                    color={AppColors.appGrayColor_1C1C1C}
                    height={2}
                    marginTop={0}
                    marginBottom={0}
                    marginHorizontal={0}
                  />
                  <RevenueSplitComponent
                    organizerSplit={organizerSplit}
                    setOrganizerSplit={setOrganizerSplit}
                    challengerSplit={challengerSplit}
                    setChallengerSplit={setChallengerSplit}
                    splitTooltip={splitTooltip}
                    setSplitTooltip={setSplitTooltip}
                  />
                  <Separator
                    color={AppColors.appGrayColor_1C1C1C}
                    height={2}
                    marginTop={0}
                    marginBottom={0}
                    marginHorizontal={0}
                  />
                  <View
                    style={{
                      flexDirection: "row",
                      gap: 12,
                      alignItems: "center",
                      marginBottom: 12,
                    }}
                  >
                    <Text style={[AppFontStyle.REGULAR_ANYBODY_14, {}]}>
                      All-or-Nothing Arena (winner takes all gifts)
                    </Text>
                    <TouchableOpacity>
                      <Image
                        source={AppImages.icInfoCircle}
                        style={{
                          height:
                            deviceSize === DEVICE_SIZES.SM ||
                            deviceSize === DEVICE_SIZES.XS
                              ? 17
                              : 20,
                          width:
                            deviceSize === DEVICE_SIZES.SM ||
                            deviceSize === DEVICE_SIZES.XS
                              ? 17
                              : 20,
                          resizeMode: "contain",
                        }}
                      />
                    </TouchableOpacity>
                    <SwitchCommon
                      switchState={commonSwitch}
                      setSwitchState={setCommonSwitch}
                    />
                  </View>
                  {/* {beltDetailTooltip && ( */}
                  <View
                    style={{
                      zIndex: isOpenDuration ? -1 : 1,
                      paddingVertical:
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? 10
                          : 20,
                      paddingHorizontal:
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? 10
                          : 20,
                      borderRadius: 10,
                      gap: 10,
                      backgroundColor: AppColors.purple_453B50,
                      flexDirection:
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? formattedBeltString === "0"
                            ? "row"
                            : "column"
                          : "row",
                      minWidth:
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? "100%"
                          : 450,
                      justifyContent: "space-between",
                      // alignItems: "center",
                      ...(deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                        ? {}
                        : {
                            position: "absolute",
                            bottom: -90,
                          }),
                    }}
                  >
                    <View
                      style={{
                        gap: 10,
                      }}
                    >
                      <Text style={AppFontStyle.MEDIUM_ANYBODY_14}>
                        You have selected : {formattedBeltString} belts
                      </Text>
                      <Text style={AppFontStyle.BOLD_ANYBODY_18}>
                        worth : {totalStakeTokenAmount ?? 0}
                        credit
                      </Text>
                    </View>
                    <View style={{ alignItems: "flex-start" }}>
                      <View
                        style={{
                          paddingVertical: 10,
                          paddingHorizontal: 20,
                          borderRadius: 10,
                          backgroundColor: AppColors.black,
                        }}
                      >
                        <Text style={AppFontStyle.BOLD_ANYBODY_22}>
                          {totalStakeCurrencyAmount ?? 0}
                        </Text>
                      </View>
                    </View>
                  </View>
                  {/* )} */}
                </View>
              </View>
              <View
                style={{
                  justifyContent: "flex-end",
                  flexDirection: "row",
                  marginTop: 20,
                  gap: 10,
                  // height: 38,
                }}
              >
                <TouchableOpacity
                  style={{
                    borderRadius: 10,
                    marginBottom: 15,
                    justifyContent: "center",
                    alignItems: "center",
                    borderWidth: 2,
                    borderColor: AppColors.appViolentColor_6D08C3,
                    width: 146,
                  }}
                  onPress={() => {
                    navigation.dispatch(StackActions.pop());
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_12,
                      {
                        paddingVertical: 12,
                        paddingHorizontal: 40,
                        color: AppColors.white,
                      },
                    ]}
                  >
                    Back
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={{
                    backgroundColor: AppColors.appViolentColor_6D08C3,
                    borderRadius: 10,
                    marginBottom: 15,
                    justifyContent: "center",
                    alignItems: "center",
                    width: 146,
                  }}
                  onPress={() => {
                    checkValidation();
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_12,
                      {
                        paddingVertical: 8,
                        paddingHorizontal: 40,
                        color: AppColors.white,
                      },
                    ]}
                  >
                    Next
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </ScrollView>
        </View>
        {showYoutubePopup && (
          <StreamingAccountModal
            showPopup={showYoutubePopup}
            closePopup={closePopup}
            image={AppImages.icYoutubeStreaming}
            connected={false}
          />
        )}
        {showTwitchPopup && (
          <StreamingAccountModal
            showPopup={showTwitchPopup}
            closePopup={closePopup}
            image={AppImages.twitchStream}
            connected={true}
          />
        )}
        {connectedPopup && (
          <ConnetedPopup
            showPopup={connectedPopup}
            closePopup={() => setConnectedPopup(false)}
          />
        )}
        {showDatePicker && (
          <DateTimePickerModal
            showModal={showDatePicker}
            setShowModal={setShowDatePicker}
            selectedDate={(date) => {
              const formattedDate = dayjs(date).toISOString();
              setDateTimeInput(formattedDate);
              setSelectDate(dayjs(date).format("DD/MM/YYYY"));
              setSelectTime(dayjs(date).format("HH:mm"));
            }}
            timePicker={true}
          />
        )}
        {cornfirmPurchaseBeltModal && (
          <CornfirmPurchaseBeltModal
            setArrBeltMedalType={setArrDetermineStakes}
            arrBeltMedalType={arrDetermineStakes}
            accessToken={accessToken}
            showModal={cornfirmPurchaseBeltModal}
            userBalanceData={userBalanceData}
            setRefreshAPICall={setRefreshAPICall}
            setShowModal={setCornfirmPurchaseBeltModal}
            dataSelectedBelt={arrDetermineStakes.find(
              (item) => item.isSelected
            )}
            numberOfBelts={
              arrDetermineStakes.find((item) => item.isSelected).stakeBeltAmount
            }
            selectedBelt={(data) => {
              setBeltPurchaseSuccessModal(true);
              // setShowPaymentScreen(true);
            }}
            jumpToPurchaseToken={(isNavigate: false) => {
              if (isNavigate) {
                navigateToScreen(navigation, AppScreens.PurchaseScreen, {
                    screen: "event",
                    type: "public",
                  });
              }
            }}
          />
        )}
        {competitorModel && (
          <CompetitorsModal
            showModal={competitorModel}
            setShowModal={setCompetitorModel}
            apiData={apiData}
            setApiData={setApiData}
            accessToken={accessToken}
            setRefreshAPICall={() => {
              setRefreshAPICall;
            }}
            isUpdate={true}
            eventID={route.params.eventData.eventID}
          />
        )}
        {balancePopup && (
          <NoBalancePopup
            showPopup={balancePopup}
            closePopup={() => setBalancePopup(false)}
          />
        )}{" "}
        {inefficientBeltsPopup && (
          <InefficientBeltsPopup
            showPopup={inefficientBeltsPopup}
            closePopup={() => setInefficientBeltsPopup(false)}
          />
        )}
        {beltPurchaseSuccessModal && (
          <BeltPurchaseSuccessModal
            arrBeltMedalType={arrDetermineStakes}
            showModal={beltPurchaseSuccessModal}
            setShowModal={setBeltPurchaseSuccessModal}
            numberOfBelts={
              arrDetermineStakes.find((item) => item.isSelected).stakeBeltAmount
            }
            dataBuyBelt={arrDetermineStakes.find((item) => item.isSelected)}
            backProfileTapped={() => {
              // reloadAPIs();
            }}
          />
        )}
      </View>
    </TouchableWithoutFeedback>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    deviceflexDirection: {
      flexDirection: "row",
    },
    viewStyle: {
      width: "30%",
    },
    container: {
      flex: 1,
    },
    mainView: {
      flex: 1,
      padding: 20,
    },
    challegeMode: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
    divider: {
      height: 2,
      marginTop: 16,
      marginBottom: 16,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      width: "100%",
    },
    headerTitle: {
      color: AppColors.white,
      paddingTop: 16,
    },

    inputWrapper: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      paddingHorizontal: 12,
      borderRadius: 10,
    },
    textInputStyle: {
      paddingVertical: 18,
      paddingHorizontal: 10,
      color: AppColors.white,
      outlineStyle: "none",
    },
    buyBeltButtonStyle: {
      paddingVertical: 14,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      borderRadius: 10,
      shadowOpacity: 0,
      width: 132,
      flex: 1,
    },
    leftWrapper: {
      flex: 0.5,
      flexDirection: "column",
      gap: 12,
    },

    rightDurationWrapper: {
      width: "20%",
      flexDirection: "column",
      gap: 12,
    },
    gameWrapper: {
      width: "40%",
      flexDirection: "column",
      gap: 12,
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 16,
      },

      inputWrapper: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      textInputStyle: {
        paddingVertical: 18,
        paddingHorizontal: 10,
        color: AppColors.white,
      },
      leftWrapper: {
        flex: 0.5,

        flexDirection: "column",
        gap: 12,
      },

      rightDurationWrapper: {
        width: "20%",
        flexDirection: "column",
        gap: 12,
      },
      gameWrapper: {
        width: "40%",
        flexDirection: "column",
        gap: 12,
      },

      challegeMode: {
        flexDirection: "column",
        justifyContent: "space-evenly",
        gap: 30,
        marginBottom: 20,
      },
      viewStyle: {
        width: "47%",
      },
    },
    [DEVICE_SIZES.MD]: {
      viewStyle: {
        width: "47%",
      },

      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 16,
      },

      inputWrapper: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      textInputStyle: {
        paddingVertical: 18,
        paddingHorizontal: 10,
        color: AppColors.white,
      },
      leftWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },

      rightDurationWrapper: {
        width: "20%",
        flexDirection: "column",
        gap: 12,
      },
      gameWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },

      challegeMode: {
        flexDirection: "column",
        justifyContent: "space-evenly",
        gap: 30,
        marginBottom: 20,
      },
    },
    [DEVICE_SIZES.SM]: {
      viewStyle: {
        width: "47%",
      },

      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 16,
      },

      inputWrapper: {
        flex: 1,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      textInputStyle: {
        paddingVertical: 18,
        paddingHorizontal: 10,
        color: AppColors.white,
      },
      leftWrapper: {
        flex: 1,

        flexDirection: "column",
        gap: 12,
      },

      rightDurationWrapper: {
        width: "20%",
        flexDirection: "column",
        gap: 12,
      },
      gameWrapper: {
        width: "40%",
        flexDirection: "column",
        gap: 12,
      },

      challegeMode: {
        flexDirection: "column",
        justifyContent: "space-evenly",
        gap: 30,
        marginBottom: 20,
      },
      mainView: { padding: 10 },
    },

    [DEVICE_SIZES.XS]: {
      viewStyle: {
        width: "47%",
      },

      challegeMode: {
        flexDirection: "column",
        justifyContent: "space-evenly",
        gap: 30,
        marginBottom: 20,
      },

      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 16,
      },

      inputWrapper: {
        flex: 1,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      textInputStyle: {
        paddingVertical: 18,
        paddingHorizontal: 10,
        color: AppColors.white,
      },
      leftWrapper: {
        flex: 1,

        flexDirection: "column",
        gap: 12,
      },

      rightDurationWrapper: {
        width: "100%",
        flexDirection: "column",
        gap: 12,
      },
      gameWrapper: {
        width: "100%",
        flexDirection: "column",
        gap: 12,
      },
      mainView: { padding: 10 },
    },
  }
);
